import React, { useContext, useEffect, useRef, useState } from "react";
import classes from "./Banner.module.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import useDeviceWidth from "../../../components/device-width/UseDeviceWidth";
import { Select, Tooltip } from "antd";
import HospitalIcon from "../../../components/UI/HospitalIcon";
import branchesService from "../../../services/branches";
import departmentsService from "../../../services/departments";
import doctorsService from "../../../services/doctors";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import { useLabReport } from "../../../components/layout/Layout";
import { NavigationContext } from "../../../App";
import { useSelector } from "react-redux";
import HomeSearchIcon from "../../../components/UI/home-search-icon";
import { MUVATTUPUZHA_BRANCH_ID } from "../../../utils/constants";

const { Option } = Select;

const Banner = ({ data }) => {
  console.log("banner data", data);
  const width = useDeviceWidth();
  const swiperRef = useRef(null); // Create a ref to control the Swiper instance
  const [doctors, setDoctors] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState();
  const [selectedDepartment, setSelectedDepartment] = useState();
  const [selectedDoctor, setSelectedDoctor] = useState();
  const navigate = useNavigate();
  const { showLabReportModal, setShowLabReportModal } = useLabReport();
  const location = useLocation();
  const sessionStore = location?.pathname?.includes("/branch")
    ? "branches"
    : location?.pathname?.includes("online-consultation")
      ? "online-consultation"
      : "home";

  const { setIsBackNavigation } = useContext(NavigationContext);
  const { homeApis } = useSelector((state) => state.widget);

  const getBranches = async () => {
    const response = await branchesService.getAll();
    console.log("branches data", response);
    setBranches(response?.data);
  };

  const getDepartments = async (query) => {
    const response = await departmentsService.getAll(query);
    console.log("departments data", response);
    setDepartments(response?.data);
  };

  const getDoctors = async (query) => {
    const response = await doctorsService.getAll(query);
    console.log("doctors data", response);
    setDoctors(response?.data);
  };

  // useEffect(() => {
  //   getBranches(`?status=ACTIVE`);
  // }, []);

  useEffect(() => {
    setSelectedDepartment();
    if (selectedBranch) {
      getDepartments(`?branchId=${selectedBranch}`);
    } else {
      getDepartments();
    }
  }, [selectedBranch]);

  useEffect(() => {
    if (selectedDepartment || selectedBranch) {
      setSelectedDoctor();
      let query = "";

      if (selectedDepartment) {
        query += `?departmentId=${selectedDepartment}`;
      }

      if (selectedBranch) {
        query += query
          ? `&branchId=${selectedBranch}`
          : `?branchId=${selectedBranch}`;
      }

      getDoctors(query);
    } else {
      getDoctors();
    }
  }, [selectedDepartment, selectedBranch]);

  useEffect(() => {
    if (selectedBranch || !homeApis?.branches?.length) return;

    const defaultBranch = homeApis.branches.find((branch) => {
      const name = branch?.name?.toLowerCase?.() || "";
      const location = branch?.location?.toLowerCase?.() || "";
      return (
        branch?.hisId === MUVATTUPUZHA_BRANCH_ID ||
        name.includes("muvattupuzha") ||
        location.includes("muvattupuzha")
      );
    });

    if (defaultBranch?._id) {
      setSelectedBranch(defaultBranch._id);
    }
  }, [homeApis?.branches, selectedBranch]);

  const infoDiv = (slide) => {
    const element = (
      <>
        <h4
          data-aos="fade-right"
          data-aos-delay="100"
          className={classes.bannerHeading}
        >
          {slide?.title}
        </h4>
        <h4
          data-aos="fade-right"
          data-aos-delay="150"
          className={classes.bannerPara}
        >
          {slide?.description}
        </h4>
        <button
          data-aos="fade-right"
          data-aos-delay="200"
          className={`${classes.bookOnline} primary-hover`}
          onClick={() => {
            const yPos = window.scrollY;
            sessionStorage.setItem("scrollTargetY", yPos.toString());
            setIsBackNavigation(true);
            sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
            navigate("/consultation");
          }}
        >
          Book Your Appointment
        </button>
      </>
    );

    return (
      <>
        {/* <div className={classes.infoDiv}>
          <div className={classes.divBackground}>{element}</div>
        </div> */}
        <div className={classes.infoDiv}>
          {" "}
          <div className={classes.contentHolder}>{element}</div>
        </div>
      </>
    );
  };

  const onSearch = () => {
    const values = {
      branchId: selectedBranch,
      departmentId: selectedDepartment,
      doctorId: selectedDoctor,
    };
    const sendingValues = _.pickBy(values, _.identity);
    const fullparams = new URLSearchParams(); //important
    const filterParams = new URLSearchParams(sendingValues)?.toString();
    // fullparams.set("page", 1);
    // fullparams.set("limit", 10);
    //to avoid repeating of filters already present in params
    const filterParamsObj = new URLSearchParams(filterParams);
    for (const [key, value] of filterParamsObj.entries()) {
      if (!fullparams.has(key)) {
        fullparams.set(key, value);
      }
    }
    navigate(`/doctors?${fullparams.toString()}`);
  };

  console.log("departments cc", departments);
  console.log("branches cc", homeApis?.branches);

  const searchInputs = () => {
    return (
      <>
        <Select
          showSearch
          onChange={(value) => setSelectedBranch(value)}
          placeholder="Select Hospital"
          className="search-select"
          value={selectedBranch}
          // prefix={
          //   <img
          //     src="/img/icons/hospital-icon.svg"
          //     alt="banner"
          //     style={{ width: 15, marginTop: "5px", marginRight: "3px" }}
          //   />
          // }
          suffixIcon={
            <img
              src="/img/icons/new-drop-arrow.svg"
              alt="Icon"
              style={{ width: 14, height: 14, marginRight: "10px" }}
            />
          }
        >
          {homeApis?.branches?.map((item) => (
            <Option className="custom-option" value={item?._id}>
              {item?.name}
            </Option>
          ))}
          {/* <Option className="custom-option">Sabine hospital sabine hospital sabine kasargod</Option> */}
        </Select>
        <Select
          value={selectedDepartment}
          showSearch
          placeholder="Select Expertise"
          onChange={(value) => setSelectedDepartment(value)}
          className="search-select"
          // prefix={
          //   <img
          //     src="/img/icons/heart-icon.svg"
          //     alt="Icon"
          //     style={{ marginTop: "5px", marginRight: "3px" }}
          //   />
          // }
          suffixIcon={
            <img
              src="/img/icons/new-drop-arrow.svg"
              alt="Icon"
              style={{ width: 14, height: 14, marginRight: "10px" }}
            />
          }
        >
          {departments?.map((item) => (
            <Option className="custom-option" value={item?._id}>
              {item?.department_name}
            </Option>
          ))}
        </Select>
        <Select
          showSearch
          placeholder="Select Doctor"
          onChange={(value) => setSelectedDoctor(value)}
          className="search-select"
          value={selectedDoctor}
          // prefix={
          //   <img
          //     src="/img/icons/doc-icon.svg"
          //     alt="Icon"
          //     style={{ marginTop: "5px", marginRight: "3px" }}
          //   />
          // }
          suffixIcon={
            <img
              src="/img/icons/new-drop-arrow.svg"
              alt="Icon"
              style={{ width: 14, height: 14, marginRight: "10px" }}
            />
          }
        >
          {doctors?.map((item) => (
            <Option className="custom-option" value={item?._id}>
              {item?.doctor_name}
            </Option>
          ))}
        </Select>
        <button
          className={`${classes.searchButton} primaryhome-search`}
          onClick={() => {
            const yPos = window.scrollY;
            sessionStorage.setItem("scrollTargetY", yPos.toString());
            setIsBackNavigation(true);
            sessionStorage.setItem("scrollOrigin", sessionStore); // or "branch" depending on the page
            onSearch();
          }}
        >
          {" "}
          {/* <img
            src="/img/icons/search.svg"
            alt="search"
            //   style={{ marginTop: "5px", marginRight: "3px" }}
          /> */}
          <HomeSearchIcon />
          Search
        </button>
      </>
    );
  };

  return (
    <div className="banner-outer">
      {/* <h1>Title for this website</h1> */}
      <div style={{ position: "relative", width: "100%", margin: "auto" }}>
        {/* <div className={classes.rightIcons}>
          <Tooltip
            className="banner-tooltip"
            title="Lab Report"
            overlayInnerStyle={{ backgroundColor: "#7f4a9b", color: "#fff" }}
          >
            <div className={`${classes.iconWrap} bg-primary-500`} onClick={()=>setShowLabReportModal(true)}>
              <img src="/img/icons/lab-report.svg" />
            </div>
          </Tooltip>
          <Tooltip
            title="Book Appointment"
            overlayInnerStyle={{ backgroundColor: "#7f4a9b", color: "#fff" }}
          >
            <div className={`${classes.iconWrap} bg-primary-500`} onClick={()=>navigate('/consultation')}>
              <img src="/img/icons/book-appointment.svg" />
            </div>
          </Tooltip>
        </div> */}
        {/* <img
          src="/img/designs/banner-top-dots.svg"
          alt="banner-dots"
          className={classes.sliderDesign}
        /> */}

        {/* {infoDiv()} */}

        {/* Swiper */}
        <Swiper
          className="banner-swiper"
          modules={[Navigation, Pagination, Autoplay]} // Enable navigation and pagination
          slidesPerView={1} // Show 3 images at a time
          spaceBetween={20} // Add space between slides
          onSwiper={(swiper) => (swiperRef.current = swiper)} // Attach the Swiper instance to the ref
          pagination={{ clickable: true }} // Enable clickable dots
          loop={true} // Enable infinite looping
          style={{ marginBottom: "-4px" }} // Add space for pagination dots
          draggable={true} // Enable drag/swipe functionality
          autoplay={{
            delay: 6000, // Delay between transitions (in milliseconds)
            disableOnInteraction: false, // Keep autoplay running even after user interaction
          }}
        >
          {data?.listingItems?.map((slide) => (
            <SwiperSlide key={slide.id}>
              <div>{infoDiv(slide)}</div>
              <img
                src={width > 1000 ? slide.webImage : slide.mobileImage}
                // src={image}
                // alt={Slide ${slide.id}}
                alt="banner"
                className={classes.sliderImage}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {width > 1200 && (
        <div style={{ display: "flex", alignItems: "center" }}>
          <div className={classes.searchDiv}>{searchInputs()}</div>
        </div>
      )}
      {width < 1200 && (
        <div className={classes.searchContainer}>{searchInputs()}</div>
      )}
    </div>
  );
};

export default Banner;
